import { getObject, postObject, postVoid } from "../ChoiceApi";
import { IPatientFlagSaveSetupItem, IPatientFlagSaveSetupItemResult, IPatientFlagSetupItem, IPatientFlagPatientAssignSave, IPatientFlagPatientAssignItem, IPatientFlagSetupFlagItem, IPatientFlagDisplayOrder } from "../Models/Setup/PatientFlagSetupModel";
import { IResult } from "../Models/Result";
import { DatabaseIdTypes } from "../../Enums/ChoiceEnums";

export async function getSetupList(): Promise<IPatientFlagSetupItem[] | undefined> {
    return await getObject("api/Setup/PatientFlagSetup/GetSetupList");
}
export async function saveSetup(payload: IPatientFlagSaveSetupItem): Promise<IPatientFlagSaveSetupItemResult | undefined> {
    return await postObject("api/Setup/PatientFlagSetup/SaveSetup", payload);
} 
export async function saveAssign(payload: IPatientFlagPatientAssignSave): Promise<IResult | undefined> {
    return await postObject("api/Setup/PatientFlagSetup/SaveAssign", payload);
} 
export async function getAssignList(idType: DatabaseIdTypes, identifier: number): Promise<IPatientFlagPatientAssignItem[] | undefined> {
    return await getObject(`api/Setup/PatientFlagSetup/GetAssignList/${idType}/${identifier}`);
}
export async function deleteSetup(payload: IPatientFlagSetupFlagItem): Promise<IResult | undefined> {
    return await postObject("api/Setup/PatientFlagSetup/DeleteSetup", payload);
} 

// Get the display order of patient flags for the current user
export async function getUserFlagDisplayOrder(): Promise<IPatientFlagDisplayOrder[] | undefined> {
    return await getObject("api/Setup/PatientFlagSetup/DisplayOrder");
}

// Save the display order of patient flags for the current user
export async function saveUserFlagDisplayOrder(flagDisplayOrderValues: IPatientFlagDisplayOrder[]): Promise<void> {
    await postVoid("api/Setup/PatientFlagSetup/DisplayOrder", flagDisplayOrderValues)
}